export enum PAYMENT_FORM_CODE {
  DEBITO_BANCARIO_CUENTA_CORRIENTE = '2',
  DEBITO_BANCARIO_CAJA_AHORRO = '3',
  EFECTIVO = '4',
  TARJETA_CREDITO = '1',
}
